/* eslint-disable react/jsx-props-no-spreading */
import { IconEye, IconEyeOff } from "@tabler/icons-react";
import { useState } from "react";

import TextInput, { TextInputProps } from "../TextInput/TextInput";

type PasswordInputProps = Omit<TextInputProps, "rightIcon" | "type">;

const PasswordInput = (inputProps: PasswordInputProps) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const onClick = () => setShowPassword((prev) => !prev);
  return (
    <TextInput
      {...inputProps}
      type={showPassword ? "text" : "password"}
      rightIcon={showPassword
        ? <IconEyeOff className="cursor-pointer" onClick={() => onClick()} />
        : <IconEye className="cursor-pointer" onClick={() => onClick()} />}
    />
  );
};

export default PasswordInput;
